import { RefObject, useEffect, useState } from 'react'

export interface SizeableHTMLElement {
  offsetWidth: number
  offsetHeight: number
}

export const useElementSize = <T extends SizeableHTMLElement>(ref: RefObject<T | null>) => {
  const [size, setSize] = useState<{ width: number; height: number } | null>(null)

  useEffect(() => {
    const getSize = () =>
      ref.current
        ? {
            width: ref.current.offsetWidth,
            height: ref.current.offsetHeight,
          }
        : null

    const handleResize = () => {
      setSize(getSize())
    }

    if (ref.current) {
      setSize(getSize())
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [ref])

  return size
}
